import { Button } from "@/components/ui/button"
import { BodyMedium } from "@/components/ui/typography"
import { Edit, FileDown, Plus } from "lucide-react"

interface ReportHeaderProps {
	isLocked: boolean
	onEdit: () => void
	onExport: () => void
	onUnlock: () => void
	onNew: () => void
	newVisible?: boolean
	unlockVisible?: boolean
}

export function ReportHeader({
	isLocked,
	onEdit,
	onExport,
	onUnlock,
	unlockVisible,
	newVisible,
	onNew,
}: ReportHeaderProps) {
	return (
		<div className="flex items-center gap-3 mb-2.5">
			<Button
				variant="outline"
				className="gap-2.5 text-foreground"
				size={"lg"}
				onClick={onEdit}
			>
				Edit Report
				<Edit className="w-4 h-4" />
			</Button>
			{newVisible && (
				<Button
					variant="outline"
					className="gap-2.5 text-foreground"
					size={"lg"}
					onClick={onNew}
				>
					New Report
					<Plus className="w-4 h-4" />
				</Button>
			)}
			<Button
				variant="outline"
				className="gap-2.5 text-foreground"
				size={"lg"}
				onClick={onExport}
			>
				{isLocked ? "🔒" : ""} Export to PDF
				<FileDown className="w-4 h-4" />
			</Button>
			{unlockVisible && (
				<Button
					className="ml-auto text-primary-foreground"
					size={"lg"}
					onClick={onUnlock}
				>
					Unlock Full Report
				</Button>
			)}
		</div>
	)
}
